import React from 'react';
import { CheckIcon } from 'lucide-react';
export function Pricing() {
  return <section id="pricing" className="py-16 md:py-24 bg-gradient-to-r from-blue-50 to-indigo-50" data-id="element-123">
      <div className="container mx-auto px-4" data-id="element-124">
        <div className="text-center mb-16" data-id="element-125">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-126">
            Simple, Transparent Pricing
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-127">
            Get your ITIN quickly and efficiently with our partner's
            all-inclusive service.
          </p>
        </div>
        <div className="max-w-4xl mx-auto" data-id="element-128">
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden" data-id="element-129">
            <div className="p-8 md:p-12" data-id="element-130">
              <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8" data-id="element-131">
                <div data-id="element-132">
                  <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-133">
                    Complete ITIN Application Service
                  </h3>
                  <p className="text-gray-600" data-id="element-134">
                    Everything you need to get your ITIN as a foreign
                    entrepreneur
                  </p>
                </div>
                <div className="mt-4 md:mt-0" data-id="element-135">
                  <div className="flex items-center" data-id="element-136">
                    <span className="text-gray-500 text-lg line-through mr-2" data-id="element-137">
                      $349
                    </span>
                    <span className="text-3xl font-bold text-gray-900" data-id="element-138">
                      $299
                    </span>
                  </div>
                  <div className="text-sm text-green-600 font-medium" data-id="element-139">
                    Save $50 with code: "Super Neil"
                  </div>
                </div>
              </div>
              <div className="bg-blue-50 rounded-xl p-6 mb-8" data-id="element-140">
                <div className="flex items-center mb-4" data-id="element-141">
                  <div className="bg-blue-600 text-white p-2 rounded-full mr-3" data-id="element-142">
                    <CheckIcon size={20} data-id="element-143" />
                  </div>
                  <span className="text-blue-800 font-medium" data-id="element-144">
                    Limited Time Offer: $50 OFF with code "Super Neil"
                  </span>
                </div>
                <p className="text-blue-700 ml-11" data-id="element-145">
                  Enter this exclusive coupon code during checkout to receive
                  your discount!
                </p>
              </div>
              <div className="grid md:grid-cols-2 gap-6 mb-8" data-id="element-146">
                <div data-id="element-147">
                  <h4 className="font-semibold text-gray-900 mb-4" data-id="element-148">
                    What's Included:
                  </h4>
                  <ul className="space-y-3" data-id="element-149">
                    <li className="flex" data-id="element-150">
                      <CheckIcon className="text-green-500 mr-2 flex-shrink-0" size={20} data-id="element-151" />
                      <span className="text-gray-700" data-id="element-152">
                        Complete ITIN application preparation
                      </span>
                    </li>
                    <li className="flex" data-id="element-153">
                      <CheckIcon className="text-green-500 mr-2 flex-shrink-0" size={20} data-id="element-154" />
                      <span className="text-gray-700" data-id="element-155">
                        IRS-certified acceptance agent review
                      </span>
                    </li>
                    <li className="flex" data-id="element-156">
                      <CheckIcon className="text-green-500 mr-2 flex-shrink-0" size={20} data-id="element-157" />
                      <span className="text-gray-700" data-id="element-158">
                        Document certification (no originals needed)
                      </span>
                    </li>
                    <li className="flex" data-id="element-159">
                      <CheckIcon className="text-green-500 mr-2 flex-shrink-0" size={20} data-id="element-160" />
                      <span className="text-gray-700" data-id="element-161">
                        IRS submission on your behalf
                      </span>
                    </li>
                  </ul>
                </div>
                <div data-id="element-162">
                  <h4 className="font-semibold text-gray-900 mb-4" data-id="element-163">
                    Once ITIN is approved:
                  </h4>
                  <ul className="space-y-3" data-id="element-164">
                    <li className="flex" data-id="element-165">
                      <CheckIcon className="text-green-500 mr-2 flex-shrink-0" size={20} data-id="element-166" />
                      <span className="text-gray-700" data-id="element-167">
                        Apply for Amazon US seller accounts
                      </span>
                    </li>
                    <li className="flex" data-id="element-168">
                      <CheckIcon className="text-green-500 mr-2 flex-shrink-0" size={20} data-id="element-169" />
                      <span className="text-gray-700" data-id="element-170">
                        Ability to open TikTok shop accounts
                      </span>
                    </li>
                    <li className="flex" data-id="element-171">
                      <CheckIcon className="text-green-500 mr-2 flex-shrink-0" size={20} data-id="element-172" />
                      <span className="text-gray-700" data-id="element-173">
                        Eligibility for US bank accounts
                      </span>
                    </li>
                    <li className="flex" data-id="element-174">
                      <CheckIcon className="text-green-500 mr-2 flex-shrink-0" size={20} data-id="element-175" />
                      <span className="text-gray-700" data-id="element-176">
                        Dedicated support throughout the process
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="text-center" data-id="element-177">
                <a href="https://theitin.com/ref/598/" target="_blank" rel="noopener noreferrer" className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-md font-medium text-lg inline-block w-full md:w-auto transition-colors" data-id="element-178">
                  Apply Now & Save $50
                </a>
                <p className="text-gray-500 mt-3 text-sm" data-id="element-179">
                  Secure payment • 100% satisfaction guarantee • Fast processing
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}